import axios from "axios";

export const crearCuponSuscriptores = ({entidad}) => {


    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/68797d72-d3c1-4434-9516-ad7e4310314d', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/68797d72-d3c1-4434-9516-ad7e4310314d',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}